module.exports = __webpack_public_path__ + "static/media/featureConnected_illust.560d298d.jpg";